import BaseMystery from '../BaseMystery'

const SixthSorrow = () => {
	const imagesList = [
		"https://upload.wikimedia.org/wikipedia/commons/6/65/Pieta_de_Michelangelo_-_Vaticano.jpg",
	];

	const titleText = "Mary holds the Body of Jesus";
	const scriptureQuote = "After this, Joseph of Arimathea, secretly a disciple of Jesus for fear of the Jews, asked Pilate if he could remove the body of Jesus. And Pilate permitted it. So he came and took his body.";
	const scriptureCitation = "John 19:38 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=John%2019%3A38-42&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default SixthSorrow;